module.exports = __webpack_public_path__ + "static/media/hero.d7caa74a.jpg";